module.exports = __webpack_public_path__ + "static/media/car.918dc55c.png";